import React, { useRef, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { Button, Card, CardContent, CardActions, Grid, Divider, colors, Paper, Tooltip, IconButton, InputBase } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: '2px 4px',
		display: 'flex',
		alignItems: 'center',
		width: '100%',
		height: '100%',
	},
	input: {
		marginLeft: theme.spacing(1),
		flex: 1,
	},
	iconButton: {
		padding: 10,
	},
	divider: {
		height: 28,
		margin: 4,
	},
}));

const FilePicker = (props) => {
	const { value, onChange, accept, placeholder } = props;
	const classes = useStyles();
	const inputFile = useRef(null);

	const _selectFile = () => {
		inputFile.current.click();
	};

	const _onChange = (event) => {
		onChange(event);
	};

	return (
		<Paper className={classes.root}>
			<InputBase
				className={classes.input}
				placeholder={placeholder || 'Selected file'}
				value={value || ''}
				inputProps={{ 'aria-label': 'selected file' }}
				disabled
			/>
			<Divider className={classes.divider} orientation="vertical" />
			<Tooltip title="Select file">
				<IconButton
					color="primary"
					className={classes.iconButton}
					onClick={_selectFile}
					aria-label="selectfile"
					size="large"
				>
					<AttachFileIcon />
				</IconButton>
			</Tooltip>
			<input id="file" type="file" accept={accept || '*'} ref={ref => { inputFile.current = ref; }} onChange={_onChange} style={{ display: 'none' }} />
		</Paper>
	);
};

FilePicker.propTypes = {
	value: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	accept: PropTypes.string,
	placeholder: PropTypes.string
};

export default FilePicker;
